export const tr = {
    'low-sum-hint': 'Reklam kampanyalarınızı başlatmak için ortak hesaba para yatırın',
    'wallet-button': 'Ortak hesap'
};
